import React from 'react';
import validator from 'validator';
import ReCAPTCHA from 'react-google-recaptcha';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloudUpload from '@material-ui/icons/CloudUpload';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';

import AppActions from '../../../actions/app-actions';
import AppStore from '../../../stores/app-store';
//VEP-2142
//import { ewcDeploymentTypeMapvalue, ewcHostRegionMapvalue } from '../../../helpers';
//import { HOSTED_BY_SMARDTV } from '../../../constants/app-constants';
import { ewcDeploymentTypeMapvalue } from '../../../helpers';
import { Divider } from '@material-ui/core';

// import Form from '../../common/forms/form';
// import TextInput from '../../common/forms/textinput';
// import FormCheckbox from '../../common/forms/formcheckbox';
// import SelectInput from '../../common/forms/selectinput';

class OrgDataEntry extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { data={} } = props;
    this.state = {
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      mobilePhoneNumber: data.mobilePhoneNumber || '',
      mobileError: data.mobileError || false,
      mobileHelpText: data.mobileHelpText || '',
      organization: data.organization || '',
      addressLine1: data.addressLine1 || '',
      addressLine2: data.addressLine2 || '',
      city: data.city || '',
      country: data.country || '',
      postalCode: data.postalCode || '',
      postalError: data.postalError || false,
      postalHelpText: data.postalHelpText || '',
      tenantName: data.tenantName || '',
      tenantNameStatus: data.tenantNameStatus || 'initial',
      tenantError: data.tenantError || false,
      tenantHelpText: data.tenantHelpText || '',
      uuid: data.uuid || '',
      uuidStatus: data.uuidStatus || 'initial',
      uuidError: data.uuidError || false,
      uuidHelpText: data.uuidHelpText || '',
      hostedBy: data.hostedBy || 1,
      //VEP-2142
      //hostRegion: data.hostRegion || '',
      tos: data.tos || false,
      marketing: data.marketing || false,
      recaptcha: ''
    };
    this.menuItems = ewcDeploymentTypeMapvalue();
    //VEP-2142
    //this.menuHostRegionItems = ewcHostRegionMapvalue();
    this.tenantNameRegEx = /^([a-z0-9]){5,12}$/;
    this.hostedHelpTxt = {
      1: 'SmarDTV support team will contact you via registered email after hosting EWC.',
      2: `Follow below instructions to download EWC configuration.
          1. Login to your account once signup completed. 
          2. Go to My organization page by clicking setting menu in the top right corner. 
          3. Download EWC config file.
          4. Use the EWC Config file as input configuration for EWC instance deployment.`
    };
    this.recaptchaSiteKey = AppStore.getRecaptchaSiteKey();
  }

  handleSubmit = () => {
    if (this.recaptchaSiteKey !== '' && this.state.recaptcha === '') {
      return AppActions.setSnackbar('Please complete the reCAPTCHA test before proceeding!', 5000, '');
    }
    return this.props.onSubmit(this.state);
  }

  setMobileNumer = e => {
    const { value:mobilePhoneNumber } = e.target;
    const mobileError = mobilePhoneNumber.length ? !validator.isMobilePhone(mobilePhoneNumber, 'any') : false;
    const mobileHelpText = mobileError && mobilePhoneNumber.length ? 'Please enter phone number with country code and without space in between' : '';
    this.setState({ mobilePhoneNumber, mobileError, mobileHelpText });
  }

  setPostalCode = e => {
    const { value:postalCode } = e.target;
    const postalError = postalCode.length ? !validator.isPostalCode(postalCode, 'any') : false;
    const postalHelpText = postalError && postalCode.length ? 'Please enter valid postal code' : '';
    this.setState({ postalCode, postalError, postalHelpText });
  }

  setTenantName = e => {
    const { value: tenantName } = e.target;
    let tenantError = false;
    let tenantHelpText = '';
    if (tenantName.length && !this.tenantNameRegEx.test(tenantName)) {
      tenantError = true;
      tenantHelpText = 'Tenant name can be a-z, 0-9 and min lenght of 5 and max length of 12';
    }
    this.setState({ tenantName, tenantError, tenantHelpText, tenantNameStatus: 'initial' });
  }

  tenantNameCheck = () => {
    this.setState({ tenantNameStatus: 'verify' });
    AppActions.veifyTenantNameAvailability(this.state.tenantName)
      .then(() => this.setState({ tenantNameStatus: 'success' }))
      .catch(() => this.setState({ tenantNameStatus: 'failed', tenantHelpText: 'Tenant name already exist', tenantError: true }))
  }

  setUuid = e => {
    const { value: uuid } = e.target;
    let uuidError = false;
    let uuidHelpText = '';
    if (uuid.length && !validator.isUUID(uuid)) {
      uuidError = true;
      uuidHelpText = 'Please enter valid UUID';
    }
    this.setState({ uuid, uuidError, uuidHelpText, uuidStatus: 'initial' });
  }

  uuidCheck = () => {
    this.setState({ uuidStatus: 'verify' });
    AppActions.verifyUuidAvailability(this.state.uuid)
      .then(() => this.setState({ uuidStatus: 'success'}))
      .catch(() => this.setState({ uuidStatus: 'failed', uuidHelpText: 'UUID already exist', uuidError: true }))
  }

  getIconByStatus (status, disabled, hnd) {
    switch (status) {
    default:
    case 'initial':
      return (
        <IconButton disabled={disabled} onClick={hnd}>
          <CloudUpload />
        </IconButton>
      );
    case 'verify':
      return (
        <IconButton disabled={true}>
          <CircularProgress size='1.5rem' />  
        </IconButton>
      );
    case 'success':
      return (
        <IconButton disabled={true}>
          <DoneIcon style={{ color: 'green' }}/>
        </IconButton>
      );
    case 'failed':
      return (
        <IconButton disabled={true}>
          <CloseIcon color='primary' />
        </IconButton>
      );
    }
  }

  isDisabledButton = () => {
    const { state } = this;
    return !(
      state.firstName && state.lastName && state.mobilePhoneNumber && !state.mobileError && 
      state.organization && state.addressLine1 && state.city && state.country && state.postalCode &&
      !state.postalError && state.tenantName && (state.tenantNameStatus === 'success') && !state.tenantError &&
      state.uuid && (state.uuidStatus === 'success') && !state.uuidError && state.tos && state.recaptcha && state.hostedBy
      //VEP-2142
      //((state.hostedBy === HOSTED_BY_SMARDTV) ? (state.hostRegion) : true)
    );
  }

  render() {
    return (
      <form>
        <h1>Setting up your Account</h1>
        <h2 className="margin-bottom-large">
          To finish creating your account,
          <br />
          please fill in a few details
        </h2>
        <Grid container>
          <Grid item xs={5}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField label="First Name" fullWidth required value={this.state.firstName} onChange={e => this.setState({ firstName: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Last Name" fullWidth required value={this.state.lastName} onChange={e => this.setState({ lastName: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Mobile Phone Number" fullWidth required value={this.state.mobilePhoneNumber} helperText={this.state.mobileHelpText}
                  error={this.state.mobileError} onChange={this.setMobileNumer}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Organization" fullWidth required value={this.state.organization} onChange={e => this.setState({ organization: e.target.value })} />
              </Grid>
              <Grid item xs={12}>
                <TextField label="Address Line 1" fullWidth required value={this.state.addressLine1} onChange={e => this.setState({ addressLine1: e.target.value })} />
              </Grid>
              <Grid item xs={12}>
                <TextField label="Address Line 2" fullWidth value={this.state.addressLine2} onChange={e => this.setState({ addressLine2: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="City" fullWidth required value={this.state.city} onChange={e => this.setState({ city: e.target.value })} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Postal Code" fullWidth required value={this.state.postalCode} helperText={this.state.postalHelpText}
                  error={this.state.postalError} onChange={this.setPostalCode} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Country" fullWidth required value={this.state.country} onChange={e => this.setState({ country: e.target.value })} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} justify='center' style={{ display: 'flex' }}>
            <Divider orientation="vertical" middle light/>
          </Grid>
          <Grid item xs={5}>
            <Grid container alignItems='center' spacing={1}>
              <Grid item md={10} lg={10}>
                <TextField label="Tenant Name" required style={{ minWidth: '100%'}} value={this.state.tenantName} helperText={this.state.tenantHelpText}
                  error={this.state.tenantError} onChange={this.setTenantName} 
                />
              </Grid>
              <Grid item md={2} lg={2} justify='flex-end'>
                {this.getIconByStatus(this.state.tenantNameStatus, this.state.tenantError || !this.state.tenantName, this.tenantNameCheck)}
              </Grid>
              <Grid item md={10} lg={10}>
                <TextField label="UUID" required style={{ minWidth: '100%'}} value={this.state.uuid} helperText={this.state.uuidHelpText} 
                  error={this.state.uuidError} onChange={this.setUuid}
                />
              </Grid>
              <Grid item md={2} lg={2} justify='flex-end'>
                {this.getIconByStatus(this.state.uuidStatus, this.state.uuidError || !this.state.uuid, this.uuidCheck)}
              </Grid>
              <Grid item xs={12}>
                <TextField label="EdgeWay Connect (video endpoint) :" value={this.state.hostedBy} select fullWidth helperText={this.hostedHelpTxt[this.state.hostedBy]}
                  onChange={e => {
                    this.setState({ hostedBy: e.target.value });
                    /* VEP 2142
                    if(e.target.value != HOSTED_BY_SMARDTV) {
                      this.setState({ hostedBy: e.target.value, hostRegion: '' });
                    }else {
                      this.setState({ hostedBy: e.target.value });
                    }*/
                  }}
                >
                  {
                    this.menuItems.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </TextField>
              </Grid>
              { //VEp-2142
                /*(this.state.hostedBy === HOSTED_BY_SMARDTV) ? (
                  <Grid item xs={12}>
                    <TextField label="Hosting Region" value={this.state.hostRegion} select fullWidth required
                      onChange={e => this.setState({ hostRegion: e.target.value })}
                    >
                      {
                        this.menuHostRegionItems.map((item, idx) => (
                          <MenuItem key={idx} value={item.label}>
                            {item.label}
                          </MenuItem>
                        ))
                      }
                    </TextField>
                  </Grid>
                ) : null */
              }
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 30 }}>
            <FormControlLabel
              required
              control={
                <Checkbox checked={this.state.tos} onChange={(_, checked) => this.setState({ tos: checked })} />
              }
              label={
                <label>
                By checking this you agree to our{' '}
                  <a>
                  Terms of service
                  </a>{' '}
                and{' '}
                  <a>
                  Privacy Policy
                  </a>{' '}
                  *
                </label>
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              required
              control={
                <Checkbox checked={this.state.marketing} onChange={(_, checked) => this.setState({ marketing: checked })} />
              }
              style={{marginTop: 0 }}
              label="By checking this you agree that we can send you occasional email updates about SmarDTV. You can unsubscribe from these emails at any time"
            />
          </Grid>
          <Grid item xs={12} justify='center' style={{ display: 'flex'}}>
            {this.recaptchaSiteKey ? (
              <div className="margin-top">
                <ReCAPTCHA sitekey={this.recaptchaSiteKey} onChange={recaptcha => this.setState({ recaptcha })} />
              </div>
            ) : <span></span>}            
          </Grid>
          <Grid item xs={12} justify='center' style={{ display: 'flex', marginTop: 30 }}>
            <Button variant='contained' color='primary' onClick={this.handleSubmit} 
              disabled={this.isDisabledButton()}>Complete Signup
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default OrgDataEntry;
